import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml',
})
export class WdxSafeHtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(value: string | unknown, option?: 'resourceUrl') {
        const safeValue =
            typeof value === 'string' ? value : String(value ?? '');

        if (option === 'resourceUrl') {
            return this.sanitizer.bypassSecurityTrustResourceUrl(safeValue);
        }

        return this.sanitizer.bypassSecurityTrustHtml(safeValue);
    }
}
